import { api } from "../config";

/**
 * Get the base API URL from centralized config
 * Auto-detects environment: localhost for development, production URL for build
 */
export const getApiUrl = () => {
  return api.API_URL;
};

/**
 * Build a full API endpoint URL
 * @param {string} endpoint - The endpoint path (e.g., '/customers', '/reminders')
 * @returns {string} - Full API URL
 */
export const buildApiUrl = (endpoint) => {
  const baseUrl = getApiUrl();
  return `${baseUrl}${endpoint}`;
};
